__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-2ccc48a1/_next/";